export default __webpack_public_path__ + "static/media/logo-capitaria-black.c979da24.svg";